<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('/admin/medical_faq')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Add Medical FAQ</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <!-- <p>Question</p>
        <base-input
          alternative
          class="mb-3"
          name="question"
          :rules="{ required: true }"
          placeholder="Enter Question"
          v-model="question"
        >
        </base-input> -->
        <base-input
          label="Enter Question"
          name="question"
          :rules="{ required: true }"
        >
          <quill-editor
            v-model="question"
            :options="editorOption"
            class="quill-h200px my-2"
          />
        </base-input>

        <!-- <p>Enter Answer</p>
        <base-input
          alternative
          class="mb-3"
          name="answer"
          placeholder="Enter Answer"
          v-model="answer"
          :rules="{ required: true }"
        >
        </base-input> -->
        <base-input
          label="Enter Answer"
          name="answer"
          :rules="{ required: true }"
        >
          <quill-editor
            v-model="answer"
            :options="editorOption"
            class="quill-h200px my-2"
          />
        </base-input>

        <p>Category</p>
        <b-form-select
          v-model="category"
          :options="options"
          @change="handleCategory()"
          alternative
          class="mb-3"
          :rules="{ required: true }"
        ></b-form-select>

        <!-- <p>SubCategory</p>
        <b-form-select
          v-model="subcategory"
          :options="Suboptions"
          alternative
          class="mb-3"
          :rules="{ required: true }"
        ></b-form-select> -->

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { mapState } from "vuex";
import "vue-advanced-cropper/dist/style.css";
import { Cropper } from "vue-advanced-cropper";
// import Data from "../../../../../admin/pages/add-product/components/Data";

export default {
  components: {
    FileUploader,
    quillEditor,
    Cropper,
  },
  data() {
    return {
      question: "",
      category: null,
      // subcategory: null,
      options: [
        { value: null, text: "Please select Category" },
        { value: "Palliative", text: "Palliative" },
        { value: "Cancer", text: "Cancer" },
        { value: "Dementia", text: "Dementia" },
        { value: "Neurological Disorders", text: "Neurological Disorders" },
      ],
      // Suboptions: [{ value: null, text: "Please select SubCategory" }],
      answer: "",
      editorOption: {
        theme: "snow",
      },
    };
  },

  methods: {
    handleCategory() {
      // console.log("cateogry", this.category);
      // if (this.category === "Palliative") {
      //   // Return subcategories related to Palliative
      //   this.Suboptions = [
      //     {
      //       value: "About Palliative Care",
      //       text: "About Palliative Care",
      //     },
      //     { value: "History", text: "History" },
      //     {
      //       value: "Principals & Framework ",
      //       text: "Principals & Framework ",
      //     },
      //     {
      //       value: "Issues & Importance",
      //       text: "Issues & Importance",
      //     },
      //   ];
      // } else if (this.category === "Cancer") {
      //   // Return subcategories related to Cancer
      //   this.Suboptions = [
      //     { value: "About Cancer", text: "About Cancer" },
      //     {
      //       value: "Treatment Options",
      //       text: "Treatment Options",
      //     },
      //     { value: "Side Effects", text: "Side Effects" },
      //     {
      //       value: "Emotional Support",
      //       text: "Emotional Support",
      //     },
      //     { value: "Nutrition", text: "Nutrition" },
      //     {
      //       value: "Financial Support",
      //       text: "Financial Support",
      //     },
      //   ];
      // }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },

    async onSubmit() {
      // let FormData = require("form-data");
      let payload = {
        question: this.question.trim(),
        category: this.category,
        // subcategory: this.subcategory,
        answer: this.answer.trim(),
      };

      // data.append("question", this.question.trim());
      // data.append("category", this.category.trim());
      // data.append("subcategory", this.subcategory.trim());
      // data.append("answer", this.answer.trim());

      let loader = this.$loading();

      try {
        const newsdata = await this.$store.dispatch(
          "medicalFaq/createMedicalFaq",
          payload
        );
        console.log(newsdata, "555");

        if (newsdata.code == 200) {
          this.$router.push({ name: "/admin/medical_faq" });
          this.$swal.fire({
            text: " Successfully Added",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        } else if (response.message === "Question already exists.") {
          // Handle duplicate question case
          this.$swal.fire({
            title: "Warning",
            text: "This question already exists.",
            icon: "warning",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        loader.close();
      } catch (error) {
        if (error.response.status) {
          this.$swal.fire({
            title: "Error",

            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      }
    },

    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
